export default __webpack_public_path__ + "static/media/DCC-Logo.f2e32a3a.svg";